<template>
<div class="table-list finished">
        <modal class="alarm" :display="alarm" @modalStatus="closeModal()" >
            <img class="alarm-img" src="../../../../assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除預定合約</h1>
            <div class="content">
                確定刪除 ”{{alarmAddress}}”之結束預定合約嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteContract, $analytics.logEvent('刪除結束預定合約', { screen_name: '刪除結束預定合約'})">確認</button>
                <button class="border-button" @click="closeModal()">取消</button>
            </div>
        </modal>
        <div class="mask"></div>
        <div class="btn-group">
            <rent-select class="finished" refName="finished" selectMsg="所有狀態" @getId="getSelectId" :setDefault="isDefault" border="1px solid #d5dad8" bgColor="#fff">
                <ul>
                    <li data-id="1">
                        預定成功
                    </li>
                    <li data-id="2">
                        租客拒絕合約
                    </li>
                    <li data-id="3">
                        房東拒絕合約
                    </li>
                </ul>
            </rent-select>
            <table-search @changeWord="setFilterWord" :setDefault="isDefault"></table-search>
        </div>
        <div class="table-list-title">
            <span class="address">房源地址</span>
            <span class="name">房源名稱</span>
            <span class="status">狀態</span>
            <span class="rent">租金</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-show="filterByWord.length == 0 && finishedList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button"  @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-show="finishedList.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(house, index) in filterByWord" :key="index" >
                    <span class="address">{{house.address}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="status">
                        <span class="success" v-if="house.contractStatus == 9">預定成功</span>
                        <span class="fail" v-if="house.contractStatus == 4 || house.contractStatus == 6 || house.contractStatus == 8">租客拒絕合約</span>
                        <span class="fail" v-if="house.contractStatus == 3 || house.contractStatus == 5">房東拒絕合約</span>
                    </span>
                    <span class="rent">{{toCurrency(house.rentPrice)}}</span>
                    <span class="action" >
                        <dot-dropmenu>
                            <ul >
                                <li v-if="house.isPaperContract" @click="getContractPDF(house.contractCid), $analytics.logEvent('查看紙本合約', { screen_name: '查看紙本合約'})">紙本合約</li>
                                <li v-else @click="getContract(house.contractCid), $analytics.logEvent('查看合約', { screen_name: '查看合約'})">查看合約</li>
                                <li :data-id="index" @click="openModal">刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import Modal from '@/components/widge/Modal.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { 
    apiGetBookingFinishedTableList,
    apiGetContract,
    apiDeleteContract,
    baseDomain
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            finishedList: [],
            contractState: '',
            filterWord: '',
            filterEmpty: false,
            bookingFinishedDataEmpty: false,
            bookingFinishedDataError: false,
            alarm: false,   
            deleteId: '',
            isDefault: false,
            isLoading: false
        }
    },
    mounted () {
        // this.$analytics.logEvent('預定管理_結束預定合約', { screen_name: '預定管理_結束預定合約'})
        this.getBookingFinishedList()
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false

            if( value.ref == 'finished' ){
                if(value.id == 1){
                    this.contractState = [9]
                }else if(value.id == 2){
                    this.contractState = [4, 6, 8]
                }else if(value.id == 3){
                    this.contractState = [3, 5]
                }
            }
        },
        closeModal: function (type) {
            this.alarm = false
        },
        openModal: function () {
            this.alarm = true
            this.deleteId = event.target.dataset.id
        },
        setFilterWord: function (value) {
            this.isDefault = false
            this.filterWord = value
        },
        setFilterDefault: function (value) {
            this.isDefault = true
            this.filterWord = ''
            this.contractState = ''
        },
        getBookingFinishedList: function () {
            apiGetBookingFinishedTableList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // this.finishedList = res.data.result
                    this.$store.dispatch('setApiStatus', 'success')
                    this.isLoading = false
                    if( res.data.result ){
                        if( res.data.result.length > 0 ){
                            this.finishedList = res.data.result
                        }else{
                            this.bookingFinishedDataEmpty = true
                        }
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                   
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        deleteContract: function () {
            let data = this.finishedList[this.deleteId].contractCid;
            // console.log(data)
            apiDeleteContract(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.closeModal()
                    this.getBookingFinishedList()
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        filterByState: function () {
            return this.finishedList.filter((finishedItem) => {
                if( this.contractState.length > 0 ){
                    if( this.contractState.includes(finishedItem.contractStatus) ){
                        return finishedItem
                    }
                }else{
                    return finishedItem
                }
            });
        },
        filterByWord: function () {
            return this.filterByState.filter((finishedItem) => {
                if( this.filterWord ){
                    if( finishedItem.houseName.includes(this.filterWord) || finishedItem.address.includes(this.filterWord)){
                        return finishedItem
                    }
                }else{
                    return finishedItem
                }
            });
        },
        filterResult: function () {
             if( this.bookingFinishedDataEmpty == false && this.bookingFinishedDataError == false && this.isLoading == false ){
                if( this.filterByWord.length == 0 ){
                    this.filterEmpty = true
                }else{
                    this.filterEmpty = false
                    return this.filterByWord
                }
            }
        },
        alarmAddress: function () {
            if( this.deleteId ){
                let address =  this.finishedList[this.deleteId]
                return address.address
            }
        }
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        RentSelect,
        TableSearch
    }
}
</script>
<style lang="scss" scoped>
    .table-list.finished{
        .table-list-title .address,
        .table-list-body ul li .address{
            position: relative;
            width: 248px;
            margin-right: 137px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
        }
        .table-list-title .name,
        .table-list-body ul li .name{
            width: 137px;
            margin-right: 100px;
        }
        .table-list-title .status,
        .table-list-body ul li .status{
            width: 132px;
            margin-right: 137px;
        }
        .table-list-title .rent,
        .table-list-body ul li > .rent{
            width: 51px;
            margin-right: 99px;
        }
        .table-list-body ul li > .rent{
            text-align: right;
        }
        .table-list-body ul li .status{
            .success,
            .fail{
                width: 84px;
                height: 20px;
                border-radius: 4px;
                padding: 9px 24px;
                font-weight: 500;
                text-align: center;
            }
            .success{
                background-color: rgba(113, 170, 229, 0.1);
                color: #71aae5;
            }
            .fail{
                background-color: #f3f3f3;
                color: #676362;
            }
        }
        > .btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: -86px;
            right: 0px;
            .rent-select.finished{
                width: 102px;
                background: #fff;
                padding: 14px 16px;
                margin-right: 16px;
            }
            
        } 
        .alarm{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .table-list.finished{
            .table-list-title .address,
            .table-list-body ul li .address{
                margin-right: 133px;
            }
            .table-list-title .name,
            .table-list-body ul li .name{
                margin-right: 96px;
            }
            .table-list-title .status,
            .table-list-body ul li .status{
                margin-right: 133px;
            }
            .table-list-title .rent,
            .table-list-body ul li > .rent{
                margin-right: 123px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/bookingManagement/BookingFinishedTableList.vue